require('./sessionExpiration.style.scss');

class SessionExpirationController {
    constructor($scope, $filter, crudService, storageService, sharedPersistenceService, principalService, logoutService) {
        this.$scope = $scope;
        this.$filter = $filter;
        this.crudService = crudService;
        this.storageService = storageService;
        this.principalService = principalService;
        this.logoutService = logoutService;
        this.REST_ENDPOINTS = sharedPersistenceService.getRestEndpoints();
        this.showModal = false;
        this.title = this.$filter('translate')('main.sessionExpiration.title');
    }

    $onInit() {
        if (angular.isUndefined(this.storageService.getToken())) return;
        this.actionButtons = [
            {
                title: this.$filter('translate')('main.nav.top.user.logout.label'),
                action: () => this.logoutService.logout(),
                btnClass: 'ctx-btn-secondary',
                id: 'logout'
            },
            {
                type: "submit",
                title: this.$filter('translate')('main.sessionExpiration.continue'),
                action: () => {
                    this.resetSessionExpireTime();
                },
                isDisabled: () => { return false; },
                id: 'session-expiration-continue'
            }];
    }

    onOpen() {
        this.watcher = this.$scope.$watch(() => this.principalService.timeLeftBeforeTokenExpire(), timeLeft => {
            switch (timeLeft) {
                case 120:
                    this.modalTimeLeftText = this.$filter('translate')('main.sessionExpiration.message.minutes');
                    break;
                case 60:
                    this.modalTimeLeftText = this.$filter('translate')('main.sessionExpiration.message.minute');
                    break;
                case 30:
                    this.modalTimeLeftText = this.$filter('translate')('main.sessionExpiration.message.seconds');
                    break;
            }
        });
    }

    resetSessionExpireTime() {
        this.principalService.resetSessionExpireTime();
        this.showModal = false;
    }

    onClose() {
        this.watcher();
    }
}

SessionExpirationController.$inject = ['$scope', '$filter', 'crudService', 'storageService', 'sharedPersistenceService', 'principalService', 'logoutService'];

const sessionExpirationComponent = {
    controller: SessionExpirationController,
    template: require('./sessionExpiration.template.html'),
    bindings: {
        showModal: '='
    }
};

module.exports = sessionExpirationComponent;


// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/dialogs/sessionExpiration/sessionExpiration.component.js